import axios from 'axios';
import { generateIconElement, ICON } from "../../Icons/Icons";

/**
 * SubscriptionCancelModal - Component for handling subscription cancellation
 */
class SubscriptionCancelModal {
  /**
   * Get the modal template
   * @returns {string} HTML template
   */
  modalTemplate() {
    return `
      <div class="confirm-modal confirm-modal--light-theme confirm-modal--type-warning middle" id="cancel-subscription-modal">
        <div class="confirm-dialog">
          ${generateIconElement(ICON.CLOSE, { classes: 'confirm-close' }).prop('outerHTML')}
          
          <div class="confirm-header-wrapper">
            <h2 class="confirm-header" data-lang="cancel-subscription-title">${$trans('cancel-subscription-title')}</h2>
          </div>
          
          <div class="confirm-body">
            <div>
              <div data-lang="cancel-subscription-warning">
                ${$trans('cancel-subscription-warning')}
              </div>
              
              <div data-lang="cancel-subscription-note">
                <p>${$trans('cancel-subscription-note')}</p>
              </div>
            </div>
            <div id="cancel-subscription-error-message" class="p-4 mt-2"></div>
          </div>
          
          <div class="confirm-footer">
            <button id="confirm-cancel-subscription" class="buttn primary" data-lang="cancel-subscription-confirm">
              ${$trans('cancel-subscription-confirm')}
            </button>
            <button id="close-cancel-subscription-modal" class="buttn secondary" data-lang="cancel-subscription-cancel">
              ${$trans('cancel-subscription-cancel')}
            </button>
          </div>
        </div>
      </div>
    `;
  }

  /**
   * Constructor
   */
  constructor({ subscriptionId = null } = {}) {
    this.subscriptionId = subscriptionId;
    this.isSubmitting = false;

    this.render();

    this.$modal = $('#cancel-subscription-modal');
    this.$confirmButton = this.$modal.find('#confirm-cancel-subscription');
    this.$closeButton = this.$modal.find('#close-cancel-subscription');
    this.$cancelButton = this.$modal.find('#close-cancel-subscription-modal, .confirm-close');
    this.$messageContainer = this.$modal.find('#cancel-subscription-message');
    this.$errorMessageContainer = this.$modal.find('#cancel-subscription-error-message');

    this.addEventListeners();
  }

  /**
   * Render the modal template
   */
  render() {
    // Check if modal already exists
    if ($('#cancel-subscription-modal').length === 0) {
      $('body').append(this.modalTemplate());
    }
  }

  /**
   * Add event listeners to the modal
   */
  addEventListeners() {
    // Close button in header
    this.$closeButton.on('click', () => {
      this.hide();
    });

    // Cancel button
    this.$cancelButton.on('click', () => {
      this.hide();
    });

    // Confirm button
    this.$confirmButton.on('click', () => {
      this.cancelSubscription();
    });

    // Close modal when clicking outside
    $(document).on('click', (event) => {
      if (this.$modal.hasClass('visible') && !$(event.target).closest('.confirm-dialog').length && !$(event.target).closest('.confirm-close').length && !$(event.target).closest('.cancel-subscription-btn').length) {
        this.hide();
      }
    });
  }

  /**
   * Send the cancellation request
   */
  cancelSubscription() {
    if (!this.subscriptionId) {
      this.showMessage('Error: No subscription ID found', 'error');
      return;
    }

    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.showLoading();

    axios.post('/billing/cancel-subscription', {
      subscription_id: this.subscriptionId
    }, {
      headers: {
        'X-CSRF-Token': window.yii.getCsrfToken(),
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.data.success) {
        this.showMessage(response.data.message, 'success');

        // Reload the page after a short delay
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        this.showMessage(response.data.message || 'An error occurred during cancellation', 'error');
        this.hideLoading();
        this.isSubmitting = false;
      }
    })
    .catch(error => {
      this.showMessage('An error occurred during cancellation', 'error');
      console.error('Cancellation error:', error);
      this.hideLoading();
      this.isSubmitting = false;
    });
  }

  /**
   * Show a message in the modal
   * @param {string} message - The message to display
   * @param {string} type - Type of message (success, error, warning)
   */
  showMessage(message, type = 'warning') {
    this.$errorMessageContainer.removeClass('has-background-danger-light has-background-warning-light has-background-success-light');
    this.$errorMessageContainer.addClass('has-background-' + type + '-light');
    this.$errorMessageContainer.text(message);
    this.$errorMessageContainer.show();
  }

  /**
   * Set the subscription ID
   * @param {string} id - The subscription ID
   */
  setSubscriptionId(id) {
    this.subscriptionId = id;
  }

  /**
   * Show the modal
   */
  show() {
    this.$modal.addClass('visible');
    this.$errorMessageContainer.hide();
  }

  /**
   * Hide the modal
   */
  hide() {
    this.$modal.removeClass('visible');
  }

  /**
   * Show loading state
   */
  showLoading() {
    this.$confirmButton.addClass('is-loading');
    this.$confirmButton.prop('disabled', true);
    this.$confirmButton.text('Processing...');
    this.$closeButton.prop('disabled', true);
    this.$cancelButton.prop('disabled', true);
  }

  /**
   * Hide loading state
   */
  hideLoading() {
    this.$confirmButton.removeClass('is-loading');
    this.$confirmButton.prop('disabled', false);
    this.$confirmButton.text('Yes, Cancel My Subscription');
    this.$closeButton.prop('disabled', false);
    this.$cancelButton.prop('disabled', false);
  }
}

export default SubscriptionCancelModal;
